import React, { useState, useEffect } from 'react';
import { Eye, Users, TrendingUp } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const VideoStatsWidget = ({ gameId }) => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await axios.get(`${API}/analytics/video/stats/${gameId}/summary`);
        setStats(response.data);
      } catch (err) {
        console.debug('VideoStatsWidget error:', err);
      } finally {
        setLoading(false);
      }
    };

    if (gameId) {
      fetchStats();
    } else {
      setLoading(false);
    }
  }, [gameId]);

  if (loading || !stats || stats.total_views === 0) {
    return null;
  }

  return (
    <div 
      data-testid="video-stats-widget"
      style={{
        display: 'flex',
        gap: '20px',
        padding: '10px 16px',
        background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
        borderRadius: '8px',
        marginTop: '12px',
        marginBottom: '12px',
        flexWrap: 'wrap',
        alignItems: 'center',
        border: '1px solid #dee2e6'
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
        <Eye size={16} color="#6c757d" />
        <span style={{ fontSize: '14px', color: '#212529', fontWeight: 500 }}>{stats.total_views}</span>
        <span style={{ fontSize: '13px', color: '#6c757d' }}>просмотров</span>
      </div>
      
      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
        <Users size={16} color="#6c757d" />
        <span style={{ fontSize: '14px', color: '#212529', fontWeight: 500 }}>{stats.unique_viewers}</span>
        <span style={{ fontSize: '13px', color: '#6c757d' }}>зрителей</span>
      </div>
      
      {stats.avg_completion_percent > 0 && (
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <TrendingUp size={16} color="#6c757d" />
          <span style={{ fontSize: '14px', color: '#212529', fontWeight: 500 }}>{Math.round(stats.avg_completion_percent)}%</span>
          <span style={{ fontSize: '13px', color: '#6c757d' }}>досмотрено</span>
        </div>
      )}
    </div>
  );
};

export default VideoStatsWidget;
